import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { length, slice, isNil, filter, values, findIndex, propEq, move, remove, clone, type as RamdaType } from 'ramda';
import CheckIcon from '@components/@core/CheckIcon';
import Dropdown from '@components/@core/Dropdown';
import Input from '@components/@core/Input';
import Pagination from '@components/@core/Pagination';
import EditDropdown from '@components/EditDropdown';
import { QuotaRequirement } from '~/services/config';

class QuotaList extends Component {
    constructor(props) {
        super(props);

        const months = [...Array(12).keys()].map((key) => ({
            id: key + 1,
            value: key + 1,
            label: `${key + 1}`,
        }));

        this.state = {
            curPage: 1,
            totalPage: 1,
            perPage: 7,
            selected: [],
            required: '',
            quotas: [],
            options: props.quotaOptions,
            months,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!(nextProps.modules === prevState.quotas)) {
            const { perPage, curPage } = prevState;
            const from = (curPage - 1) * perPage;
            const to = curPage * perPage;
            const totalPage = Math.ceil(length(nextProps.modules) / perPage);
            const selected = slice(from, to, nextProps.modules);
            return {
                quotas: nextProps.modules,
                selected,
                totalPage,
            };
        }
        return null;
    }

    handleChangePage = (page) => {
        const { totalPage, perPage } = this.state;
        const { modules } = this.props;
        if (page > totalPage) return;
        const from = (page - 1) * perPage;
        const to = page * perPage;
        const selected = slice(from, to, modules);
        this.setState({ curPage: page, selected });
    };

    handleSelectCalculation = (type, item) => (e) => {
        const calc = e[0];
        let modules = {};
        if (type === 'calculation') {
            modules = this.props.modules.map((m) => {
                if (m.id === item.id) {
                    return { ...item, quota_calculation: calc.value };
                }
                return m;
            });
        } else if (type === 'month') {
            modules = this.props.modules.map((m) => {
                if (m.id === item.id) {
                    return { ...item, span_months: calc.value, minimum_months: calc.value };
                }
                return m;
            });
        } else if (type === 'requirement') {
            modules = this.props.modules.map((m) => {
                if (m.id === item.id) {
                    return { ...item, quota_direction: calc.value };
                }
                return m;
            });
        }
        this.props.onChange(modules);
    };

    handleChangeTarget = (item) => (e) => {
        const quota_target = Number(e);
        const modules = this.props.modules.map((m) => {
            if (m.id === item.id) return { ...item, quota_target };
            else return m;
        });
        this.props.onChange(modules);
    };
    handleChangeActual = (item) => (e) => {
        const quota_value = Number(e);
        const modules = this.props.modules.map((m) => {
            if (m.id === item.id) return { ...item, quota_value };
            else return m;
        });
        this.props.onChange(modules);
    };

    handleSelectMenu = (item) => (e) => {
        const { quotas } = this.state;
        const index = findIndex(propEq('id', item.id), quotas);
        let modules = clone(quotas);
        switch (e) {
            case 'move up':
                modules = move(index, index - 1, modules);
                break;
            case 'move down':
                modules = move(index, index + 1, modules);
                break;
            case 'remove':
                modules = remove(index, 1, modules);
                break;
            default:
                break;
        }
        this.props.onChange(modules);
    };

    render() {
        const { totalPage, perPage, curPage, selected, options, months } = this.state;
        const quotaOptions = RamdaType(options) === 'Array' ? options : values(options);

        return (
            <div className="library-programs-list px-0">
                <div className="programs-module-list">
                    <div className="desktop-flex py-2">
                        <div className="d-flex-6 px-0">
                            <div className="dsl-m12">Goal</div>
                        </div>
                        <div className="d-flex-5 px-0">
                            <div className="dsl-m12">Calculation</div>
                        </div>
                        <div className="d-flex-2 px-0">
                            <p className="dsl-m12">Months</p>
                        </div>
                        <div className="d-flex-3 px-0">
                            <div className="dsl-m12">Greater/Less Than</div>
                        </div>
                        <div className="d-flex-2 px-0">
                            <div className="dsl-m12">Target</div>
                        </div>
                        <div className="edit" />
                    </div>
                    {length(selected) > 0 ? (
                        <>
                            {selected.map((item, index) => {
                                if (isNil(item.id)) return null;
                                let dotsMenu = ['Move Down', 'Move Up', 'Remove'];
                                if (index === 0) {
                                    dotsMenu = filter((x) => !(x === 'Move Up'), dotsMenu);
                                }
                                if (index + 1 === length(selected)) {
                                    dotsMenu = filter((x) => !(x === 'Move Down'), dotsMenu);
                                }
                                return (
                                    <div className="mx-0 d-flex list d-flex ssm-column align-items-left py-2" key={item.id}>
                                        <div className="d-flex-6 d-h-between w-100 px-0">
                                            <div className="d-h-start">
                                                <CheckIcon size={26} checked={!isNil(item.completed_at)} />
                                                <p className="dsl-b14 mb-0 ms-2">{item.name || item.data.name}</p>
                                            </div>
                                            <EditDropdown className="mobile-screen ms-2" options={dotsMenu} onChange={this.handleSelectMenu(item)} />
                                        </div>
                                        <div className="d-flex-5 px-0 d-h-start">
                                            <label className="dsl-b14 mb-0 mobile-screen w-40">Calculation</label>
                                            <Dropdown
                                                placeholder="Select"
                                                width="fit-content"
                                                returnBy="data"
                                                defaultIds={[Number(item.quota_calculation)]}
                                                data={quotaOptions}
                                                getValue={(e) => e['label']}
                                                onChange={this.handleSelectCalculation('calculation', item)}
                                            />
                                        </div>
                                        <div className="d-flex-2 px-0 d-h-start">
                                            <label className="dsl-b14 mb-0 mobile-screen w-40">Month</label>
                                            {Number(item.quota_calculation) === 3 && (
                                                <Dropdown
                                                    placeholder="Select"
                                                    width="fit-content"
                                                    returnBy="data"
                                                    defaultIds={[Number(item.span_months)]}
                                                    data={months}
                                                    getValue={(e) => e['label']}
                                                    onChange={this.handleSelectCalculation('month', item)}
                                                />
                                            )}
                                        </div>
                                        <div className="d-flex-3 px-0 d-h-start">
                                            <label className="dsl-b14 mb-0 mobile-screen w-40">Greater/Less Than</label>
                                            <Dropdown
                                                placeholder="Select"
                                                width="fit-content"
                                                returnBy="data"
                                                data={QuotaRequirement}
                                                defaultIds={[Number(item.quota_direction)]}
                                                getValue={(e) => e['name']}
                                                onChange={this.handleSelectCalculation('requirement', item)}
                                            />
                                        </div>
                                        <div className="d-flex-2 px-0 d-h-start">
                                            <label className="dsl-b14 mb-0 mobile-screen w-60">Target</label>
                                            <Input
                                                className="input-field"
                                                type="number"
                                                placeholder="Type required number here..."
                                                value={item.quota_target || 0}
                                                onChange={this.handleChangeTarget(item)}
                                            />
                                        </div>

                                        <div className="edit desktop-flex">
                                            <EditDropdown options={dotsMenu} onChange={this.handleSelectMenu(item)} />
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    ) : (
                        <p className="dsl-b16 py-4 mb-0 border-bottom">No Goals Assigned</p>
                    )}

                    <Pagination current={curPage} perPage={perPage} total={totalPage} onChange={this.handleChangePage} />
                </div>
            </div>
        );
    }
}

QuotaList.propTypes = {
    modules: PropTypes.array,
    quotaOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
    type: PropTypes.string,
    onChange: PropTypes.func,
};

QuotaList.defaultProps = {
    modules: [],
    quotaOptions: [],
    type: '',
    onChange: (e) => {},
};

export default QuotaList;
